module.exports = __webpack_public_path__ + "img/3c1464b1588c3cae.e986f8cb.gif";